import { Injectable } from '@angular/core';
import { rootPathRef } from '../../app/settings.config';
// import { QueryFn } from '@angular/fire/database/interfaces';
import {
  AngularFirestore,
  AngularFirestoreDocument,
  AngularFirestoreCollection,
  DocumentChangeAction,
  Action,
  DocumentSnapshotDoesNotExist,
  DocumentSnapshotExists,
} from 'angularfire2/firestore';
import { Observable} from 'rxjs';
// import { map, tap, take, switchMap, mergeMap, expand, takeWhile } from 'rxjs/operators';
import {take} from 'rxjs/operators';
import * as firebase from 'firebase/app';
import { Events } from 'ionic-angular';
// import { GlobaldataProvider } from '../globaldata/globaldata';

type CollectionPredicate<T> = string | AngularFirestoreCollection<T>;
type DocPredicate<T> = string | AngularFirestoreDocument<T>;

@Injectable()
export class DatabaseServiceProvider {
  rootPath: any;

  constructor(private afs: AngularFirestore, public events: Events) {
    var _clientId = localStorage.getItem('clientId');
    if(typeof _clientId === 'undefined'){
      this.rootPath = rootPathRef.path + '/';
    } else {
      this.rootPath = 'clients/' + _clientId + '/'
    }
    this.updateEvents();
    // console.log(this.rootPath);
  }
  
  updateEvents(){
    this.events.subscribe('locChange', data => {
      var _clientId = localStorage.getItem('clientId');
      if(typeof _clientId === 'undefined'){
        this.rootPath = rootPathRef.path + '/';
      } else {
        this.rootPath = 'clients/' + _clientId + '/'
      }
    })
  }
  /// **************
  /// Get a Reference
  /// **************
  col<T>(ref: CollectionPredicate<T>, queryFn?): AngularFirestoreCollection<T> {
    // console.log('collection path requested: ' +  this.rootPath + ref)
    return typeof ref === 'string' ? this.afs.collection<T>(this.rootPath + ref, queryFn) : ref;
  }

  doc<T>(ref: DocPredicate<T>): AngularFirestoreDocument<T> {
    // console.log('document path requested: ' +  this.rootPath + ref)
    return typeof ref === 'string' ? this.afs.doc<T>(this.rootPath + ref) : ref;
  }

  /// GetList, update, set and remove functions **********************
  getItemListByLoc<T extends object>(path: string): Observable<any[]> {
    // return this.col(path, ref => ref.where('locationId', '==', localStorage.getItem('selectedCity'))).snapshotChanges().pipe(map(actions => actions.map(a => ({ key: a.payload.doc.id, ...a.payload.doc.data() }))));
    return this.col(path, ref => ref.where('locationId', '==', localStorage.getItem('selectedCity'))).snapshotChanges().map(actions => {
      return actions.map(a => {
        const data = a.payload.doc.data();
        const key = a.payload.doc.id;
        return { key, ...(data as object) };
      });
    });
  }
  getItemList<T extends object>(ref: CollectionPredicate<T>, queryFn?): Observable<any[]> {
    // return this.col(ref, queryFn).snapshotChanges().pipe(map(actions => actions.map(a => ({ key: a.payload.doc.id, ...a.payload.doc.data()}))));
    return this.col(ref, queryFn).snapshotChanges().map(actions => {
      return actions.map(a => {
        const data = a.payload.doc.data();
        const key = a.payload.doc.id;
        return { key, ...(data as object)};
      });
    });
  }
  getItemObject(path: string) {
    return this.doc(path).valueChanges();
  }
  updateObject(path: string, data): Promise<any> {
    // return this.doc(path).update({...data, updated_at: this.timestamp });
    return this.updateInsert(path, { ...data, updated_at: this.timestamp })
  }
  pushList(path: string, data): Promise<any> {
    const timestamp = this.timestamp;
    // const newKey = this.afs.createId;
    // path = path + '/' + newKey;
    return this.col(path).add({ ...data, updated_at: timestamp, created_at: timestamp });  //too slow on android!!!! wtf!
  }
  pushList2(path: string, data) {
    var promise = new Promise((resolve, reject) => {
    const timestamp = this.timestamp;
    // var colRef = this.col(path);
    const newKey = this.afs.createId();
    // console.log(newKey)
    path = path + '/' + newKey;
    resolve({ id: newKey }) // promise will never resolve unless data is synced in offline mode, therefore resolve before data sync
    this.doc(path).set({ ...data, updated_at: timestamp, created_at: timestamp })
    });
    return promise
    // return colRef.doc(newKey).set({ ...data, updated_at: timestamp, created_at: timestamp })
    // return this.col(path).add({ ...data, updated_at: timestamp, created_at: timestamp });
  }
  removeObject(path: string): Promise<any> {
    return this.doc(path).delete();
  }

  /// Firebase Server Timestamp
  public get timestamp() {
    return firebase.firestore.FieldValue.serverTimestamp();
  }
  updateInsert<T>(ref: DocPredicate<T>, data: any): Promise<void> {
    const doc = this.doc(ref)
      .snapshotChanges()
      .pipe(take(1))
      .toPromise();
    return doc.then((snap: Action<DocumentSnapshotDoesNotExist | DocumentSnapshotExists<T>>) => {
      return snap.payload.exists ? this.update(ref, data) : this.set(ref, data);
    });
  }
  set<T>(ref: DocPredicate<T>, data: any) {
    const timestamp = this.timestamp;
    return this.doc(ref).set({ ...data, updated_at: timestamp, created_at: timestamp });
  }
  update<T>(ref: DocPredicate<T>, data: any) {
    return this.doc(ref).update({ ...data, updated_at: this.timestamp });
  }

/// ==== firstore does not retreive subcollections of a document in one query =====
/// ==== so for those documents that have subcollections, we will have to retreive them individually ===
/// ==== and combine them using Observable.combineLatest ===============================================

public col$<T>(ref: CollectionPredicate<T>, queryFn?): Observable<T[]> {
  // console.log('sub collection access: ' + ref);
  return this.col(ref, queryFn).snapshotChanges().map(docs => {
    return docs.map(a => a.payload.doc.data()) as T[];
  });
}

/// with Ids
public colWithIds$<T extends object>(ref: CollectionPredicate<T>, queryFn?): Observable<any[]> {
  return this.col(ref, queryFn).snapshotChanges().map(actions => {
    return actions.map(a => {
      const data = a.payload.doc.data();
      const key = a.payload.doc.id;
      return { key, ...(data as object)};
    });
  });
}

//====locations document === 
//has following subcollections: locations\{locationId} => pincode, workingHourDetails
getLocationData<T extends object>(queryFn?): Observable<any[]> {
  return this.colWithIds$('locations', queryFn)
  .switchMap(locations => {
    const resPincode = locations.map(location => {
      return this.col$(`locations/${location.key}/pincode`)
        .map(pincode => Object.assign(location, {pincode}));
    });
    return Observable.combineLatest(...resPincode);
  })
}

//====menuItems document === 
//has following subcollections: menuItems\{itemId} => price
getmenuItemsData<T extends object>(queryFn?): Observable<any[]> {
  return this.colWithIds$('menuItems', queryFn)
  .switchMap(menuItems => {
    const resPrice = menuItems.map(menuItem => {
      return this.col$(`menuItems/${menuItem.key}/price`)
        .map(price => Object.assign(menuItem, {price}));
    });
    return Observable.combineLatest(...resPrice);
  })
}

//====Orders document === 
//has following subcollections: orders\{orderId} => cart, cardReceipts, splitPayment, voidReceipts, returnReceipts, tabReceipts, adjustGratuityReceipts
getOrderData<T extends object>(queryFn?): Observable<any[]> {
  return this.colWithIds$('orders', queryFn)
  .switchMap(orders => {
    if(orders.length > 0){
    const resCart = orders.map(order => {
      return this.col$(`orders/${order.key}/cart`)
        .map(cart => Object.assign(order, {cart}));
    });
    return Observable.combineLatest(...resCart);
  } else {
    return Observable.from(orders);
  }
  })
}

getOrderDataWithCardReceipts<T extends object>(queryFn?): Observable<any[]> {
  return this.colWithIds$('orders', queryFn)
  .switchMap(orders => {
      const rescardReceipts = orders.map(order => {
        return this.col$(`orders/${order.key}/cardReceipts`)
          .map(cardReceipts => Object.assign(order, {cardReceipts}));
      });
      return Observable.combineLatest(...rescardReceipts);
  })
}
//====employees document === 
//has following subcollections: employees\{empId} => roles
getemployeesData<T extends object>(queryFn?): Observable<any[]> {
  return this.colWithIds$('employees', queryFn)
  .switchMap(employees => {
    const resRoles = employees.map(employee => {
      return this.col$(`employees/${employee.key}/roles`)
        .map(roles => Object.assign(employee, {roles}));
    });
    return Observable.combineLatest(...resRoles);
  })
}

//====users document === 
//has following subcollections: users\{userId} => address, cardDetails, favourite, tabels
getusersData<T extends object>(queryFn?): Observable<any[]> {
  return this.colWithIds$('users', queryFn)
  .switchMap(users => {
    const resaddress = users.map(user => {
      return this.col$(`users/${user.key}/address`)
        .map(address => Object.assign(user, {address}));
    });
    return Observable.combineLatest(...resaddress)
  })
}

//====settings document === 
//has following subcollections: settings\{locId} => devices, floors, roles, tables
getsettingsData<T extends object>(queryFn?): Observable<any[]> {
  return this.colWithIds$('settings', queryFn)
  .switchMap(settings => {
    const resdevices = settings.map(setting => {
      return this.col$(`settings/${setting.key}/devices`)
        .map(devices => Object.assign(setting, {devices}));
    });
    return Observable.combineLatest(...resdevices)
  })
}

//==========Taqeout.com intial search===============
colFullPath<T>(ref: CollectionPredicate<T>, queryFn?): AngularFirestoreCollection<T> {
  // console.log('collection path requested: ' +  this.rootPath + ref)
  return typeof ref === 'string' ? this.afs.collection<T>(ref, queryFn) : ref;
}
docFullPath<T>(ref: DocPredicate<T>): AngularFirestoreDocument<T> {
  // console.log('document path requested: ' +  this.rootPath + ref)
  return typeof ref === 'string' ? this.afs.doc<T>(ref) : ref;
}
getItemListFullPath<T extends object>(ref: CollectionPredicate<T>, queryFn?): Observable<any[]> {
  // return this.col(ref, queryFn).snapshotChanges().pipe(map(actions => actions.map(a => ({ key: a.payload.doc.id, ...a.payload.doc.data()}))));
  return this.colFullPath(ref, queryFn).snapshotChanges().map(actions => {
    return actions.map(a => {
      const data = a.payload.doc.data();
      const key = a.payload.doc.id;
      return { key, ...(data as object)};
    });
  });
}

//updated --- check root user collection
getRootDoc(path: string) {
  return this.afs.doc(path).valueChanges();
}
getRootCol(ref: string, queryFn?){
  return this.afs.collection(ref, queryFn).snapshotChanges().map(actions => {
    return actions.map(a => {
      const data = a.payload.doc.data();
      const key = a.payload.doc.id;
      return { key, ...(data as object)};
    });
  });
}
removeRootDoc(path: string){
  return this.afs.doc(path).delete()
}
updateRootUserInfo(uid: string, data) {
  this.afs.doc('users/' + uid).update({ ...data, updated_at: this.timestamp });
}

}


// WEBPACK FOOTER //
// ./src/providers/database-service/database-service.ts